import { and, is } from "@the-real-insight/tri-model";

/** Spelling matters: the legal lifecycle state has two `s`, unlike `OperatingState.decommisioned`. */
export const DECOMMISSIONED_ASSET_STATE = "decommissioned";

/**
 * Assets still in service (#780).
 *
 * A device decommissioned in the app is archived server-side: `assetState` becomes
 * "decommissioned" and its floor-plan position (`floor`/`space`/`x`/`y`) is cleared. The
 * archive panel (Betrieb → Anlagen-Archiv) is the one place that lists such devices; every
 * operational list — the floor's device list, the plan, a room's equipment, the site
 * overview — filters them out with this.
 *
 * The position alone would already keep an archived device off a floor. The state filter is
 * what covers the lists that are not floor-scoped (a site's assets are read by address, which
 * the archive keeps), and a device whose state was set through the legal endpoint, which
 * changes `assetState` without touching the position.
 *
 * `$ne` matches a missing field in MongoDB, so assets that carry no `assetState` at all
 * (the overwhelming majority) still pass — no migration needed. Devices decommissioned
 * before the server change carry only the measurement, no state, and need the backfill.
 */
export const activeAssetsFilter = () =>
  is("assetState").notEqual(DECOMMISSIONED_ASSET_STATE);

/** The assets actually installed on a floor: on the floor, and not archived. */
export const assetsOnFloorFilter = (floorId: string) =>
  and(is("floor").equal(floorId), activeAssetsFilter());
